(function(){
  'use strict';
  var KEY   = 'wb_l10n_ack';
  var root  = document.getElementById('wbL10n');
  if (!root) return;
  var MODE  = root ? (root.getAttribute('data-mode') || 'once') : 'once';
  var DELAY = root ? parseInt(root.getAttribute('data-delay'), 10) || 0 : 0;
  var SID   = root ? root.getAttribute('data-section-id') : '';
  var card = root.querySelector('.wb-l10n-card');
  var opener = null;

  /* Private browsing throws on storage rather than returning null. If the
     answer cannot be remembered the question must not be asked — a popup on
     every page view is worse than no popup at all. */
  function store(){
    return MODE === 'session' ? window.sessionStorage : window.localStorage;
  }
  function seen(){
    if (MODE === 'always') return false;
    try { return store().getItem(KEY) === '1'; } catch (e) { return true; }
  }
  function remember(){
    if (MODE === 'always') return;
    try { store().setItem(KEY, '1'); } catch (e) {}
  }

  function open(trigger){
    opener = trigger || null;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wb-l10n-lock');
    if (card) card.focus();
  }
  function close(persist){
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('wb-l10n-lock');
    if (persist !== false) remember();
    if (opener && opener.focus) { opener.focus(); opener = null; }
  }

  root.addEventListener('click', function(e){
    if (e.target.closest('[data-wb-l10n-close]')) close();
  });

  /* Submitting navigates away, so the flag must be written before the request
     leaves — otherwise the shopper lands on the translated page and is asked
     all over again. */
  root.addEventListener('submit', remember);

  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape' || !root.classList.contains('is-open')) return;
    /* If a picker list is open, Escape belongs to it — closing the whole
       dialog on the same keystroke would be two dismissals for one press. */
    if (root.querySelector('.wb-pick.is-open')) return;
    close();
  });

  /* Hold focus inside the dialog while it is open. */
  document.addEventListener('focusin', function(e){
    if (root.classList.contains('is-open') && !root.contains(e.target) && card) card.focus();
  });

  /* Anything tagged data-wb-l10n-open reopens it — e.g. a footer link. */
  document.addEventListener('click', function(e){
    var t = e.target.closest ? e.target.closest('[data-wb-l10n-open]') : null;
    if (!t) return;
    e.preventDefault();
    open(t);
  });

  /* ---- custom pickers ----
     Replaces each native <select> with a listbox styled like the rest of the
     store. The <select> is never removed: it keeps the value, it is what the
     form submits, and if anything in here throws, the field is left exactly as
     it was and still works. Enhancement is applied per field, so a failure on
     one cannot take out the other. */
  function enhance(wrap){
    var sel = wrap.querySelector('select');
    if (!sel || !sel.options.length) return;

    var label = document.getElementById(sel.getAttribute('id') + 'Lbl');
    var btn  = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wb-pick-btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    if (label) btn.setAttribute('aria-labelledby', label.id + ' ' + sel.id + 'Val');

    var val = document.createElement('span');
    val.className = 'wb-pick-val';
    val.id = sel.id + 'Val';
    var tag = document.createElement('span');
    tag.className = 'wb-pick-tag';
    btn.appendChild(val);
    btn.appendChild(tag);
    btn.insertAdjacentHTML('beforeend',
      '<svg class="wb-pick-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>');

    var list = document.createElement('ul');
    list.className = 'wb-pick-list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    if (label) list.setAttribute('aria-labelledby', label.id);

    var opts = [];
    for (var i = 0; i < sel.options.length; i++) {
      var o  = sel.options[i];
      var li = document.createElement('li');
      li.className = 'wb-pick-opt';
      li.setAttribute('role', 'option');
      li.setAttribute('data-value', o.value);
      li.setAttribute('aria-selected', o.selected ? 'true' : 'false');
      var n = document.createElement('span');
      n.textContent = o.getAttribute('data-name') || o.textContent;
      var t = document.createElement('span');
      t.className = 'wb-pick-tag';
      t.textContent = o.getAttribute('data-tag') || '';
      li.appendChild(n);
      li.appendChild(t);
      if (o.lang) li.setAttribute('lang', o.lang);
      list.appendChild(li);
      opts.push(li);
    }

    function paint(){
      var o = sel.options[sel.selectedIndex];
      if (!o) return;
      val.textContent = o.getAttribute('data-name') || o.textContent;
      tag.textContent = o.getAttribute('data-tag') || '';
      for (var i = 0; i < opts.length; i++) {
        opts[i].setAttribute('aria-selected', i === sel.selectedIndex ? 'true' : 'false');
      }
    }

    var active = sel.selectedIndex < 0 ? 0 : sel.selectedIndex;
    function mark(i){
      if (i < 0 || i >= opts.length) return;
      if (opts[active]) opts[active].classList.remove('is-active');
      active = i;
      opts[active].classList.add('is-active');
      list.setAttribute('aria-activedescendant', '');
      var top = opts[active].offsetTop, h = opts[active].offsetHeight;
      if (top < list.scrollTop) list.scrollTop = top;
      else if (top + h > list.scrollTop + list.clientHeight) list.scrollTop = top + h - list.clientHeight;
    }
    function openList(){
      list.hidden = false;
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      mark(sel.selectedIndex < 0 ? 0 : sel.selectedIndex);
    }
    function closeList(focus){
      list.hidden = true;
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      if (focus) btn.focus();
    }
    function choose(i){
      if (i < 0 || i >= opts.length) return;
      sel.selectedIndex = i;
      /* Fire change so anything else bound to the select still hears it. */
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      paint();
      closeList(true);
    }

    btn.addEventListener('click', function(){
      if (list.hidden) openList(); else closeList(true);
    });
    list.addEventListener('click', function(e){
      var li = e.target.closest ? e.target.closest('.wb-pick-opt') : null;
      if (li) choose(opts.indexOf(li));
    });
    list.addEventListener('mousemove', function(e){
      var li = e.target.closest ? e.target.closest('.wb-pick-opt') : null;
      if (li) mark(opts.indexOf(li));
    });
    btn.addEventListener('keydown', function(e){
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openList();
        list.focus();
      }
    });
    list.tabIndex = -1;
    list.addEventListener('keydown', function(e){
      switch (e.key) {
        case 'ArrowDown': e.preventDefault(); mark(Math.min(active + 1, opts.length - 1)); break;
        case 'ArrowUp':   e.preventDefault(); mark(Math.max(active - 1, 0)); break;
        case 'Home':      e.preventDefault(); mark(0); break;
        case 'End':       e.preventDefault(); mark(opts.length - 1); break;
        case 'Enter':
        case ' ':         e.preventDefault(); choose(active); break;
        case 'Escape':    e.preventDefault(); e.stopPropagation(); closeList(true); break;
        case 'Tab':       closeList(false); break;
      }
    });
    /* A click anywhere else in the dialog dismisses an open list. Registered on
       the dialog rather than the document so it cannot fight the popup's own
       outside-click handling. */
    root.addEventListener('click', function(e){
      if (!list.hidden && !wrap.contains(e.target)) closeList(false);
    });

    wrap.insertBefore(btn, sel);
    wrap.appendChild(list);
    wrap.classList.add('is-enhanced');
    paint();
  }

  var picks = root.querySelectorAll('[data-wb-pick]');
  for (var p = 0; p < picks.length; p++) {
    try { enhance(picks[p]); } catch (err) { /* leave the native select in place */ }
  }

  /* "Show on desktop, tap on phones" needs the open state kept in step with the
     viewport. CSS alone can force the panel visible but cannot change the
     element's open state, so a details left closed on a wide screen would
     still report itself closed to assistive tech. */
  var guide = root.querySelector('[data-wb-guide].is-auto');
  if (guide && window.matchMedia) {
    var wide = window.matchMedia('(min-width:600px)');
    var sync = function(){ guide.open = wide.matches; };
    sync();
    if (wide.addEventListener) wide.addEventListener('change', sync);
    else if (wide.addListener) wide.addListener(sync);
  }

  if (window.Shopify && window.Shopify.designMode) {
    /* Theme editor: never auto-open, or the merchant cannot work on the page.
       Instead it opens when this section is selected in the sidebar, so it can
       be styled live, and closes again on deselect without burning the
       "already seen" flag. */
    document.addEventListener('shopify:section:select', function(e){
      if (e.detail.sectionId === SID) open(null);
    });
    document.addEventListener('shopify:section:deselect', function(e){
      if (e.detail.sectionId === SID) close(false);
    });
  } else if (!seen()) {
    window.setTimeout(function(){ open(null); }, DELAY);
  }
})();
